import Vuex from 'vuex'
import User from '@/store/user'
import Alert from "@/store/alerts";

export default new Vuex.Store({
  modules: {
    User, Alert
  }
})
